module.exports = __webpack_public_path__ + "static/img/05@2x.e5d1c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/05@2x.png
// module id = b6fq
// module chunks = 1